import React, { useEffect } from "react";
import { FormContent, supplierData2Form, supplierForm2Data } from "./utils";
import { Form, Row, Col, Button, Spin, Message, Empty, Space } from "@bedrock/components";
import { useSupplierDetail } from "mpc-common/containers/SupplierMgr/component/models/supplierDetail";
import { useMemoizedFn, useSize } from "ahooks";
import { Edit, Eye, Save as SaveIcon} from "@bedrock/icons-react";
import NoData from '@bedrock/components/es/Empty/images/small/NoData'
import SFormItem from "@mpc/common/src/components/SForm/SFormItem";
import classNames from "classnames";
import UserList from "mpc-common/containers/SupplierMgr/component/SupplierDetail/UserList";
import AccountTable from "mpc-common/containers/SupplierMgr/component/SupplierDetail/AccountTable";
import _ from "lodash";;
import SupplierType from "../SupplierType";
import { ChannelSupplierDetailVo, outsourceNewSupplierQueryById, outsourceNewSupplierUpdateById } from "services/api";
import "./index.less"
import { downloadFile } from "mpc-common/utils/download";
import { localPx2rem } from "@mpc/common/src/utils";
import { useScreenAdapterContext } from '@bedrock/eed-react'
import PageFooter from '@mpc/common/src/features/PageFooter';
import ContractInformation from "@mpc/common/src/features/ContractInformation";

const viewClass = "supplier-view";

export type Account = {
    /** 用户名 */
    username?: string;
    /** 邮件 */
    email?: string;
    /** popo账号 */
    popo_account?: string;
};

type SupplierDetailProps = {
    isFullscreen?: boolean,
    history?: any,
    location?: any,
    suppliersList?: Array<Record<string, any>>,
    headerButton?: ({
        getValidateFormData,
    }) => React.ReactNode
}

const SupplierDetail = (props: SupplierDetailProps) => {
    const { isFullscreen, headerButton, history, location, suppliersList } = props
    const {
        supplierDetail,
        openType,
        closeDetail,

        viewToEdit,

    } = useSupplierDetail();
    const { viewBase } = useScreenAdapterContext();

    const [detalLoading, setDetalLoading] = React.useState(false)
    const [newSupplierDetail, setNewSupplierDetail] = React.useState<ChannelSupplierDetailVo | undefined>(undefined)
    const [id, setId] = React.useState(0)

    const { status } = supplierDetail;
    // 已入库供应商
    const activeSupplier = status?.toString() === '1';

    const [form] = Form.useForm()
    const accountListRef = React.useRef(null)
    const isView = ['view', 'check'].includes(openType)
    const taggetContainer = document.getElementsByClassName('supple-new-container')[0]
    const taggetSider = document.getElementsByClassName('beehive-layout-sider')[0]
    const containerSize = useSize(taggetContainer)
    const siderSize = useSize(taggetSider)
    const styles = {
        width: isFullscreen ? '100vw' : (containerSize?.width + 48) + 'px',
        left: isFullscreen ? 0 : siderSize?.width + 'px',
        top: isFullscreen ? 0 : localPx2rem(60)
    }

    // 初始化数据
    useEffect(() => {
        const id = suppliersList?.find(item => item.selected)?.id
        setId(id)
        outsourceNewSupplierQueryById({ id }).then(res => {
            if (res.code === 1) {
                setNewSupplierDetail(res?.data)
                form?.setFieldsValue?.(supplierData2Form(res?.data))
            }
        }).catch(err => { console.log(err) })
    }, [suppliersList])

    const renderData = {...newSupplierDetail}
    
    const onFormChange = useMemoizedFn((data, allVata) => {
    })

    const principalsRef = React.useRef(null)
    const contactsRef = React.useRef(null)

    const getValidateFormData = useMemoizedFn(() => {
        const dataPromise = Promise.all([form?.validateFields?.(),
        contactsRef?.current?.validateFields?.(), // 单独校验联系人
        principalsRef?.current?.validateFields?.(), // 单独校验负责人
        ]).then(([values, contacts, accounts]) => {
            const data = supplierForm2Data(values)
            return data
        })
        dataPromise.catch(() => {
            Message.error('有信息未填写或填写错误，请检查')
        })
        return dataPromise
    })

    const renderContentTitle = (title) => {
        return (
            <div className={`${viewClass}-content-head`}>
                <div className={`${viewClass}-icon`}></div>
                <div className={`${viewClass}-title`}>{title}</div>
            </div>
        )
    }

    const buttonRenderParams = React.useMemo(() => {
        return {
            getValidateFormData,
        }
    }, [])

    const renderHeaderButton = () => {
        switch (openType) {
            case 'edit':
                return (
                    <>
                        <Button
                            type="checked-neutral"
                            loading={detalLoading}
                            onClick={() => {
                                history.push('/outCompanyManagement/outCompanyInfo');
                                closeDetail()
                            }}>取消</Button>
                        <Button
                            loading={detalLoading}
                            type="primary"
                            className="out-supplier-but"
                            icon={<SaveIcon />}
                            onClick={() => {
                                const getFormValue = form?.getFieldsValue()
                                const params = {
                                    contacts: getFormValue?.contacts,
                                    principals: getFormValue?.principals,
                                    attachments: getFormValue?.main_supplier?.attachments,
                                    bank_info: getFormValue?.bank_info,
                                    contract_contact_info: getFormValue?.contract_contact_info,
                                }
                                setDetalLoading(true)
                                outsourceNewSupplierUpdateById({ id }, { ...params }).then(res => {
                                    if (res.code === 1) {
                                        Message.success('操作成功')
                                        history.push('/outCompanyManagement/outCompanyInfo');
                                        closeDetail()
                                    }
                                }).catch(err => console.log(err)).finally(() => {
                                    setDetalLoading(false)
                                })
                            }}>保存</Button>
                    </>
                )
            case 'view':
            default:
                return (
                    <>
                        {<Button className="out-supplier-but" type="primary" icon={<Edit />} onClick={() => {
                            history.push({ ...location, pathname: `${location.pathname}/edit` });
                            viewToEdit()
                        }}>编辑</Button>}
                    </>
                )
        }
    }

    return (
        <Spin.Global
            spinning={detalLoading}
            className={
                classNames(viewClass, {
                    'view-full-screen': isFullscreen,
                })}
            style={{
                ...styles
            }}>
            <div className={classNames(`${viewClass}-wrapper`)}>
                <div className={`${viewClass}-header`}>
                    <div className={`${viewClass}-header-left`}>
                        <Space size={16}>
                            <span className={`${viewClass}-header-left-span`}>
                                {
                                    ['new', 'serviceNew'].includes(openType) ? '新建供应商' : newSupplierDetail?.main_supplier?.name || '供应商详情'
                                }
                            </span>
                        </Space>
                    </div>
                    <div className={`${viewClass}-header-right`}>
                        {
                            headerButton?.(buttonRenderParams)
                        }
                        {renderHeaderButton()}
                    </div>
                </div>
                <div className={`${viewClass}-body`}>
                    <Form
                        form={form}
                        showLabelColon
                        initialValues={{}}
                        scrollToFirstError
                        layout="vertical"
                        onFieldsChange={onFormChange}>
                        <div className={`${viewClass}-content`}>
                            {
                                (function () {
                                    if (['serviceNew'].includes(openType)) {
                                        return (
                                            <div className={`${viewClass}-basin-new`}>
                                                {renderContentTitle(FormContent.base.title)}
                                                <Row gutter={[24, 16]}>
                                                    {
                                                        FormContent.base.content
                                                            .filter(item => ['main_supplier.name'].includes(item.formItemKey))
                                                            .map((item, index) => {
                                                                const { label, formItemKey, required, col, show, ...otherProps } = item
                                                                return (
                                                                    <Col span={col || 6} key={index}>
                                                                        <SFormItem
                                                                            {...otherProps}
                                                                            view={true}
                                                                            style={{ width: "100%" }}
                                                                            label={label}
                                                                            formItemKey={formItemKey}
                                                                            required={required}
                                                                            renderData={renderData}
                                                                            componentClass={item.componentClass}
                                                                            show={true}
                                                                        />
                                                                    </Col>
                                                                )
                                                            })
                                                    }
                                                </Row>
                                            </div>
                                        )
                                    }
                                    return (
                                        <Row gutter={[20 * viewBase, 0]}>
                                            <Col span={12} key={'base'}>
                                                <div className={`${viewClass}-basin`}>
                                                    {renderContentTitle(FormContent.base.title)}
                                                    <Row gutter={[24 * viewBase, 16 * viewBase]}>
                                                        {
                                                            FormContent.base.content
                                                                .map((item, index) => {
                                                                    const { label, formItemKey, required, col, show, render, ...otherProps } = item
                                                                    if (typeof show === 'function' && !show(renderData)) {
                                                                        return null
                                                                    }
                                                                    return (
                                                                        <Col span={col || 12} key={index}>
                                                                            <SFormItem
                                                                                view={true}
                                                                                render={render}
                                                                                style={{ width: "100%" }}
                                                                                label={label}
                                                                                formItemKey={formItemKey}
                                                                                required={required}
                                                                                renderData={renderData}
                                                                                componentClass={item.componentClass}
                                                                                show={true}
                                                                                elementProps={item.elementProps}
                                                                            />
                                                                        </Col>
                                                                    )
                                                                })
                                                        }
                                                    </Row>

                                                </div>
                                            </Col>
                                            <Col span={12} key={'file'}>
                                                <div className={`${viewClass}-aptitude`}>
                                                    {renderContentTitle(FormContent.file.title)}
                                                    {
                                                        FormContent.file.content
                                                            .map((item, index) => {
                                                                const { label, formItemKey, required } = item
                                                                if (!_.get(newSupplierDetail, formItemKey)?.length) {
                                                                    return <Empty
                                                                        imageNode={<NoData style={{
                                                                            width: 128,
                                                                            height: 128,
                                                                        }} />}
                                                                        text="资质文件暂未上传"
                                                                    />
                                                                }

                                                                return (
                                                                    <SFormItem
                                                                        key={index}
                                                                        className={classNames(`${viewClass}-aptitude-item`, {
                                                                            item_edit: !isView,
                                                                        })}
                                                                        view={true}
                                                                        showLabel={false}
                                                                        style={{ width: "100%" }}
                                                                        label={label}
                                                                        formItemKey={formItemKey}
                                                                        required={required}
                                                                        renderData={{}}
                                                                        componentClass={item.componentClass}
                                                                        show={true}
                                                                        elementProps={{
                                                                            multiple: true,
                                                                            limit: 20,
                                                                            fileSizeLimit: 200 * 1024 * 1024,
                                                                            tip: true,
                                                                            onDownload: (file) => {
                                                                                file?.download_url && downloadFile(file?.download_url, file.name);
                                                                            },
                                                                            renderIcon: (file) => 
                                                                                // 只有图片和PDF文件才显示预览按钮
                                                                                /(png|jpe?g|pdf)$/.test(file.name || '') && (
                                                                                    <Button
                                                                                        type="text-subtle"
                                                                                        size="xSmall"
                                                                                        icon={<Eye />}
                                                                                        onClick={ () => {
                                                                                            file?.preview_url && window.open(file?.preview_url);
                                                                                        }}
                                                                                    />
                                                                                )
                                                                        }}
                                                                    />
                                                                )
                                                            })
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    )
                                })()
                            }
                        </div>
                        <div className={`${viewClass}-service`}>
                            {renderContentTitle(FormContent.sever.title)}
                            <Row gutter={[24, 16]}>
                                {
                                    FormContent.sever.content
                                        .filter(n => {
                                            if(typeof n.show === 'function') {
                                                return n.show()
                                            }
                                            if(typeof n.show === 'boolean') {
                                                return n.show
                                            }
                                            return true
                                        })
                                        .map((item, index) => {
                                            const { label, formItemKey, required, col } = item
                                            return (
                                                <Col span={col || 6} key={index}>
                                                    <SFormItem
                                                        view={true}
                                                        style={{ width: "100%" }}
                                                        label={label}
                                                        formItemKey={formItemKey}
                                                        required={required}
                                                        renderData={{}}
                                                        componentClass={item.componentClass}
                                                        show={true}
                                                        elementProps={{
                                                            ...item.elementProps,
                                                        }}
                                                    />
                                                </Col>
                                            )
                                        })
                                }
                            </Row>
                        </div>
                        <div className={`${viewClass}-contact-person`}>
                            {renderContentTitle('联系人')}
                            <div className={`${viewClass}-person`}>
                                <div className={`${viewClass}-contact-person-title`}>{FormContent.principalUser.title}</div>
                                <Form.Item
                                    name={'principals'}
                                    showLabel={false}
                                    style={{ marginBottom: 0 }}
                                >
                                    <UserList
                                        ref={principalsRef}
                                        view={isView}
                                    />
                                </Form.Item>
                            </div>
                            <div className={`${viewClass}-person`}>
                                <div className={`${viewClass}-contact-person-title`}>{FormContent.contactUser.title}</div>
                                <Form.Item
                                    name={'contacts'}
                                    showLabel={false}
                                    style={{ marginBottom: 0 }}
                                >
                                    <UserList
                                        ref={contactsRef}
                                        view={isView}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className={`${viewClass}-type`}>
                            {renderContentTitle('供应商类型')}
                            <SupplierType newSupplierDetail={newSupplierDetail} />
                        </div>
                        {activeSupplier &&
                            (
                                <div className={`${viewClass}-userInfo`}>
                                    {renderContentTitle('账号信息')}
                                    <Form.Item
                                        name={'account_list'}
                                        showLabel={false}
                                        style={{ marginBottom: 0 }}
                                        rules={[
                                            {
                                                validator: async (rule, value) => {
                                                    const someEmpty = value?.some(n => {
                                                        return !n.username || !n.email
                                                    })
                                                    if (someEmpty) {
                                                        return Promise.reject('账号信息的用户名和邮箱 不能为空')
                                                    }
                                                    return Promise.resolve()
                                                }
                                            }
                                        ]}
                                    >
                                        <AccountTable
                                            view={isView}
                                            ref={accountListRef}
                                        />
                                    </Form.Item>
                                </div>
                            )
                        }
                         <div className={`${viewClass}-type`}>
                            {renderContentTitle('合同信息')}
                            <ContractInformation view={isView} mdm_code={newSupplierDetail?.main_supplier?.mdm_code}/>
                        </div>
                    </Form>
                    <PageFooter />
                </div>
            </div>
        </Spin.Global>
    )
}

export default SupplierDetail;
